export default __webpack_public_path__ + "static/media/caret-right.0445123c.svg";